import { V2MicrogridOverviewGetProfitDataPostResponse } from '@maxtropy/intelligent-dispath-apis-v2';
import dayjs from 'dayjs';
import { keepTwoNull } from '@/pages/IndustrialGreenMicBigScreen/utils';
import * as echarts from 'echarts';

export const getChartOption = (data?: V2MicrogridOverviewGetProfitDataPostResponse) => {
  // 收益
  let actualData = (data?.detail ?? []).map(item => [dayjs(item.time).valueOf(), keepTwoNull(item.value)]);

  const unit = '元';

  return {
    tooltip: {
      trigger: 'axis',
      backgroundColor: 'rgba(0,0,0,0.8)',
      borderColor: 'transparent',
      textStyle: {
        color: 'rgba(255,255,255,0.85)',
      },
      formatter: (items: any) => {
        let { axisValue } = items[0];
        let firstStr = dayjs(axisValue).format('YYYY-MM-DD');
        let otherStr = '';
        let str = '';

        items.forEach((item: any) => {
          const { seriesName, data, marker } = item;
          otherStr += `<div style="margin-top:8px"><span style="display:inline-block;margin-right:4px;border-radius:10px;width:10px;height:10px;">${marker}</span>${seriesName} : &nbsp;${
            data[1] || data[1] === 0 ? data[1] : '-'
          }${unit}</div>`;
          str = firstStr + otherStr;
        });

        return str;
      },
    },
    grid: {
      left: 10,
      right: 10,
      top: 30,
      bottom: 10,
      containLabel: true,
    },
    legend: [
      {
        right: 10,
        itemGap: 18,
        itemWidth: 12,
        itemHeight: 12,
        itemStyle: {
          borderWidth: 0, // 去掉边框
        },
        textStyle: {
          color: 'rgba(255,255,255,0.85)',
        },
        inactiveColor: 'rgba(255,255,255,0.45)',
        data: [
          {
            name: '收益',
            icon: 'rect',
          },
        ],
      },
    ],
    xAxis: [
      {
        type: 'time',
        axisLabel: {
          textStyle: {
            color: 'rgba(255,255,255,.85)', //坐标的字体颜色
          },
          fontSize: 10,
          formatter: (value: string) => {
            return dayjs(value).format('MM-DD');
          },
          hideOverlap: true
        },
        axisPointer: {
          type: 'shadow',
        },
        axisLine: {
          show: true, // 是否显示轴线
          lineStyle: {
            color: 'rgba(255,255,255,0.3)',
          },
        },
      },
    ],
    yAxis: [
      {
        type: 'value',
        name: unit,
        nameTextStyle: {
          color: 'rgba(255,255,255,0.85)',
        },
        axisLabel: {
          formatter: '{value}',
          textStyle: {
            color: 'rgba(255,255,255,.85)', //坐标的字体颜色
          },
        },
        splitLine: {
          show: true,
          lineStyle: {
            color: 'rgba(255,255,255,0.3)',
          },
        },
      },
    ],
    series: [
      {
        name: '收益',
        type: 'bar',
        data: actualData,
        itemStyle: {
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            { offset: 0, color: 'rgba(74,255,127,0.7)' },
            { offset: 1, color: 'rgba(216,216,216,0)' },
          ]),
        },
      },
    ],
  };
};
